import React, { Component } from 'react'
import { find } from 'libraries/lodash'
import CheckIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import dayjs from 'dayjs'
import cx from 'classnames'
import { toast } from 'react-toastify'
import { pushUrl } from 'front-end-core/core/history'
import url from 'front-end-core/core/url'
import { DISPLAY_DATE_FORMAT } from 'constants/locale'
import { LEGISLATION } from 'constants/controllers'
import {
  requestActVersions,
  createTakeoverVersion,
  publishTakeoverVersion
} from 'services/LegislationService'
import { dismissPopover } from 'services/OverlayService'
import notificationToast from 'helpers/notificationToast'
import connect from 'components/shared/connect'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Icon from 'components/shared/Icon'
import Loading from 'components/shared/Loading'

@connect(({ act }) => requestActVersions(act).map(versions => ({ versions })))
class AdminBar extends Component {
  state = {
    instructionsOpen: false
  }

  requestGroup = versionId => {
    const { act, flavour } = this.props
    pushUrl(url(LEGISLATION, { flavour, path: act, editingId: versionId }))
    // refresh(TAKEOVER_CODE, { flavour, path: act, editingId: versionId }) // TODO: doesn't work
    window.location.reload()
  }

  handleTogglePublishOverlay = () => {
    const { publishedId, versions, pageToggleOverlay } = this.props
    const { requestGroup: handleSuccess } = this
    pageToggleOverlay(
      <PublishOverlay
        publishedId={publishedId}
        versions={versions}
        onSuccess={handleSuccess}
      />
    )
  }

  handleToggleCreateOverlay = () => {
    const { editingId, versions, pageToggleOverlay } = this.props
    const { requestGroup: handleSuccess } = this
    pageToggleOverlay(
      <CreateOverlay
        {...{ editingId, versions }}
        onSuccess={handleSuccess}
      />
    )
  }

  handleToggleUserInstructions = () => {
    this.setState({ instructionsOpen: !this.state.instructionsOpen })
  }

  renderWarning = () => {
    const { editingId, versions, publishedId } = this.props
    const { original } = find(
      versions,
      v => Number(v.versionId) === Number(editingId)
    )
    const published = Number(editingId) === Number(publishedId)
    const message =
      `You are viewing the ${published ? 'published' : 'original'} version of the Takeover Code which can't be modified. Create a new version first.`
    return original || published
      ? (
        <div className='alert alert-warning'>{message}</div>
        )
      : null
  }

  renderContent = () => {
    const { requestGroup: handleOnDropdownChange } = this
    const { instructionsOpen } = this.state
    const { versions, publishedId, editingId, publisher } = this.props
    const instructionsClassName = `admin-bar__instructions${instructionsOpen ? '' : ' closed'}`

    return (
      <div className='admin-bar'>
        <div className='admin-bar__row'>
          <div className='admin-bar__panel'>
            <div className='form-group'>
              <p>
                <b>Select version to edit:</b>
              </p>
              <Dropdown
                defaultValue={editingId}
                options={versions}
                onChange={handleOnDropdownChange}
              />
            </div>
            <div className='form-group'>
              <button
                onClick={this.handleToggleCreateOverlay}
                className='btn btn-primary'
              >
                Create New
              </button>
            </div>
            {this.renderWarning()}
          </div>
          <div className='admin-bar__panel'>
            <p>
              <b>Published version: </b>
              V{publishedId}
            </p>
            {publisher
              ? (
                <div className='form-group'>
                  <button
                    onClick={this.handleTogglePublishOverlay}
                    className='btn btn-primary'
                  >
                    Change
                  </button>
                </div>
                )
              : null}
            <div className={instructionsClassName} style={{ maxHeight: instructionsOpen ? 'none' : publisher ? '220px' : '270px' }}>
              <p><b>User Instructions</b></p>
              <p>The editor is available to users with the 'takeover-editor' permission.</p>
              <p>Only users with the 'takeover-publisher' permission are able to update the version published on the site.</p>
              <p>The original version and the currently published version cannot be edited. If you need to make changes then you can create a new version.</p>
              <p>Changes are not saved until you press the save button. If you close the section without saving your changes they will be lost.</p>
              <p>Be careful not to edit a version that someone else is currently editing as you may overwrite their changes.</p>
              <p>You can only edit section header text; there is no support for changing e.g. text style.</p>
              <p>The text prefix editor is marginally more advanced:</p>
              <ul>
                <li><p>BACKSPACE inside an empty text prefix editor deletes the text prefix.</p></li>
                <li><p>CTRL + I italicises the highlighted text.</p></li>
                <li><p>CTRL + B emphasises the highlighted text.</p></li>
              </ul>
              <p>The paragraph editor has extended functionality again:</p>
              <ul>
                <li><p>ENTER creates a new paragraph immediately after the current paragraph.</p></li>
                <li><p>BACKSPACE inside an empty paragraph editor deletes the paragraph.</p></li>
                <li><p>CTRL + I italicises the highlighted text.</p></li>
                <li><p>CTRL + B emphasises the highlighted text.</p></li>
                <li><p>CTRL + ] increases the indentation of the paragraph.</p></li>
                <li><p>CTRL + [ decreases the indentation of the paragraph.</p></li>
                <li><p>CTRL + - adds an empty text prefix to the paragraph.</p></li>
              </ul>
              <a className='admin-bar__toggle-instructions pointer' href={null} onClick={this.handleToggleUserInstructions}>{instructionsOpen ? 'Less' : 'More'}</a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <ResponseConsumer
        response={this.props.versions}
        content={this.renderContent}
      />
    )
  }
}

class PublishOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toPublishId: props.publishedId,
      publishing: false
    }
  }

  handlePublishVersion = () => {
    this.setState({ publishing: true }, () => {
      const { toPublishId } = this.state
      const { onSuccess } = this.props
      publishTakeoverVersion({ id: Number(toPublishId) }).subscribe(response => {
        if (response.success) {
          notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Success!', 'bg-dark-sea-green white')
          onSuccess(null)
        } else {
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error', 'bg-indian-red white')
          this.setState({ publishing: false })
        }
      })
    })
  }

  renderLoading () {
    const { publishing } = this.state
    return publishing ? <Loading /> : null
  }

  render () {
    const { publishing, toPublishId } = this.state
    const { publishedId, versions } = this.props

    return (
      <div
        className='publish-overlay'
        onClick={e => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
      >
        <div style={{ visibility: publishing ? 'hidden' : 'visible' }}>
          <h2>Update Published Version</h2>
          <p>
            The published version is the version visible to FromCounsel users.
          </p>
          <div className='alert alert-info'>
            Currently published version: <b>V{publishedId}</b>
          </div>
          <div className='form-group'>
            <p>
              <b>Choose version to publish:</b>
            </p>
            <Dropdown
              defaultValue={toPublishId}
              options={versions}
              onChange={versionId => this.setState({ toPublishId: versionId })}
            />
          </div>
          <div className='form-group'>
            <button onClick={this.handlePublishVersion} className='btn btn-primary'>
              Confirm
            </button>
          </div>
        </div>
        {this.renderLoading()}
      </div>
    )
  }
}

class CreateOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      toCopyId: props.editingId,
      notes: '',
      creating: false
    }
  }

  handleCreateVersion = () => {
    this.setState({ creating: true }, () => {
      const { toCopyId, notes } = this.state
      const { onSuccess } = this.props
      createTakeoverVersion({ id: Number(toCopyId), notes })
        .subscribe(response => {
          if (response.success) {
            notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Success!', 'bg-dark-sea-green white')
            onSuccess(response.response)
          } else {
            notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Error', 'bg-indian-red white')
            this.setState({ creating: false })
          }
        })
    })
  }

  renderLoading () {
    const { creating } = this.state
    return creating ? <Loading /> : null
  }

  render () {
    const { creating, toCopyId, notes } = this.state
    const { versions } = this.props

    return (
      <div
        className='create-overlay'
        onClick={e => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
      >
        <div style={{ visibility: creating ? 'hidden' : 'visible' }}>
          <h2>Create New Version</h2>
          <div className='form-group'>
            <p>
              <b>Choose version to copy:</b>
            </p>
            <Dropdown
              defaultValue={toCopyId}
              options={versions}
              onChange={versionId => this.setState({ toCopyId: versionId })}
            />
          </div>
          <div className='form-group'>
            <p>
              <b>Add a note: *</b>
            </p>
            <input
              className='form-control'
              placeholder='Notes'
              type='text'
              onChange={({ target: { value } }) =>
                this.setState({ notes: value })}
            />
          </div>
          <div className='form-group'>
            <button
              disabled={notes.length <= 0}
              onClick={this.handleCreateVersion}
              className='btn btn-primary'
            >
              Create
            </button>
          </div>
        </div>
        {this.renderLoading()}
      </div>
    )
  }
}

class Dropdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  renderOption ({ versionId, notes, takeoverCodeDate, createdAt, updatedAt }) {
    return (
      <div className='admin-bar__dropdown-option'>
        <h6>V{versionId}</h6>
        <p className='admin-bar__dropdown-notes'>{notes}</p>
        <p className='admin-bar__dropdown-date'>
          <b>Last updated: </b>
          {dayjs(updatedAt).format(DISPLAY_DATE_FORMAT)}
        </p>
        <p className='admin-bar__dropdown-date'>
          <b>Created: </b>
          {dayjs(createdAt).format(DISPLAY_DATE_FORMAT)}
        </p>
        <p className='admin-bar__dropdown-date'>
          <b>Based on The Takeover Code published on: </b>
          {dayjs(takeoverCodeDate).format(DISPLAY_DATE_FORMAT)}
        </p>
      </div>
    )
  }

  renderList () {
    const { open } = this.state
    const { options, defaultValue, onChange } = this.props

    return open
      ? (
        <ul className='admin-bar__dropdown-list'>
          {options.map(option => {
            const { versionId } = option
            const className = cx({
              'admin-bar__dropdown-item--selected':
              Number(versionId) === Number(defaultValue)
            })
            return (
              <li
                key={versionId}
                className={className}
                onClick={() => onChange(versionId)}
              >
                {this.renderOption(option)}
              </li>
            )
          })}
        </ul>
        )
      : null
  }

  render () {
    const { open } = this.state
    const { options, defaultValue } = this.props

    return (
      <div
        className='admin-bar__dropdown'
        onClick={() => this.setState({ open: !open })}
      >
        <span className='admin-bar__icon'>
          <Icon
            name={{ 'icon-chevron-up': open, 'icon-chevron-down': !open }}
          />
        </span>
        {this.renderOption(
          find(options, o => Number(o.versionId) === Number(defaultValue))
        )}
        {this.renderList()}
      </div>
    )
  }
}

export default AdminBar
